import { apiAuthClient } from 'shared/api/lib';
import type {
  GetCompanyGroupsRequestType,
  GetCompanyGroupsResponseType,
  Group,
} from '../types';

export const getCompanyGroups = async ({
  pathParams: { boardId },
}: GetCompanyGroupsRequestType): Promise<Group[]> => {
  const url = `/board/${boardId}/groups`;

  const { data } = await apiAuthClient.get<GetCompanyGroupsResponseType>(url);

  return data.data;
};
